export default __webpack_public_path__ + "2a480a4ac3276c09ceae471d33989cb7.gif";